module.exports = __webpack_public_path__ + "static/img/6269_phase_function_Paper_Points.a4b1175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6269_phase_function_Paper_Points.png
// module id = 1wRj
// module chunks = 0